var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['v2-badge', `v2-badge--${_vm.variant}`],attrs:{"role":_vm.role}},[_vm._t("icon"),_c('span',{staticClass:"v2-badge__label"},[_vm._v(_vm._s(_vm.label))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }